import React from 'react';


export default function Loading() {
    return <div>
        {/* <Spin style={{ position: 'absolute', top: '50%', left: '50%'}}/> */}
    </div>
}